import React from 'react';
import Box from '@mui/material/Box';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import './FileloaderAnimation.css';

const FileLoaderAnimation = () => (
  <Box className="file-loader-animation-box" sx={{ height: '100px', overflow: 'hidden' }}>
    <DescriptionRoundedIcon style={{ '--i': 0 }} className="file-loader-animation-icon" sx={{ color: 'primary.main' }} />
    <DescriptionRoundedIcon style={{ '--i': 1 }} className="file-loader-animation-icon" sx={{ color: 'primary.main' }} />
    <DescriptionRoundedIcon style={{ '--i': 2 }} className="file-loader-animation-icon" sx={{ color: 'primary.main' }} />
    <DescriptionRoundedIcon style={{ '--i': 3 }} className="file-loader-animation-icon" sx={{ color: 'primary.main' }} />
  </Box>
);

export default FileLoaderAnimation;
